import { defineStore } from 'pinia'

export const useCartModalStore = defineStore('cartModalStore', {
  state: () => ({
    modalRef: null as any
  }),
  actions: {
    register(ref: any) {
      this.modalRef = ref
    },
    open(payload?: any, cartQty?: number) {
      this.modalRef?.open(payload, cartQty)
    }
  }
})
